import { EmergencyProcedure } from "@/types/landing";

import api from "../api";

// Map backend response to frontend EmergencyProcedure
function fromBackendPayload(proc: any): EmergencyProcedure {
  return {
    backgroundColor: proc.background_color,
    description: proc.description,
    icon: proc.icon,
    iconColor: proc.number_color,
    id: proc.id,
    isActive: proc.hidden === 0,
    order: proc.order ?? 0,
    step: proc.step_number,
    title: proc.title,
  };
}

// Map frontend EmergencyProcedure to backend payload
function toBackendPayload(proc: EmergencyProcedure) {
  return {
    background_color: proc.backgroundColor,
    description: proc.description,
    icon: proc.icon,
    number_color: proc.iconColor,
    step_number: proc.step,
    title: proc.title,
  };
}

export const EmergencyProceduresService = {
  create: async (
    procedure: EmergencyProcedure,
  ): Promise<EmergencyProcedure> => {
    const res = await api.post(
      "/emergency-procedures",
      toBackendPayload(procedure),
    );
    return fromBackendPayload(res.data.procedure);
  },

  delete: async (id: number | string): Promise<void> => {
    await api.delete(`/emergency-procedures/${id}`);
  },

  getAll: async (): Promise<EmergencyProcedure[]> => {
    const res = await api.get("/emergency-procedures");
    return (res.data.procedures || []).map(fromBackendPayload);
  },

  getById: async (id: number | string): Promise<EmergencyProcedure> => {
    const res = await api.get(`/emergency-procedures/${id}`);
    return fromBackendPayload(res.data.procedure);
  },

  hide: async (id: number | string): Promise<void> => {
    await api.post(`/emergency-procedures/${id}/hide`);
  },

  unhide: async (id: number | string): Promise<void> => {
    await api.post(`/emergency-procedures/${id}/unhide`);
  },

  update: async (
    id: number | string,
    procedure: EmergencyProcedure,
  ): Promise<EmergencyProcedure> => {
    const res = await api.put(
      `/emergency-procedures/${Number(id)}`,
      toBackendPayload(procedure),
    );
    return fromBackendPayload(res.data.procedure);
  },
};
